export default __webpack_public_path__ + "static/media/employee_icon.57a506b1.svg";